
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/play/search",
      function () {
        return require("private-next-pages/play/search.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/play/search"])
      });
    }
  